import React, { Component, Fragment } from 'react';
import Snackbar from 'material-ui/Snackbar';
import Button from '@material-ui/core/Button';

class IrwinIdTextField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSnackbar: false
    };
  }

  closeSnackbar = () => {
    this.setState({showSnackbar: false})
  }

  render()
  {
    return (
      <Fragment>
      <Button size="small" color="primary" id={"button-" + this.props.irwinId} onClick={e => {
      this.setState({
        showSnackbar: true
      });
      navigator.clipboard.writeText(this.props.irwinId);}}>{this.props.irwinId}</Button>
      <Snackbar
        open={this.state.showSnackbar}
        id={"snack-" + this.props.irwinId}
        message="Copied to clipboard"
        autoHideDuration={2000}
        onRequestClose={this.closeSnackbar}
      />
     </Fragment>);
  }

}

export default IrwinIdTextField;
